import axios from 'axios';
import { saveLeadinDB } from '../utilities';
import { supabase } from '../../../services/supabase';
// import { get } from '../../utils/request';
import { get, post } from '../../../utils/request';
import moment from 'moment';
import momenttz from 'moment-timezone';

export const getPropertySupabase = async (magnetuuid) => {
  try {
    console.log('community_magnets', magnetuuid);
    let { data: Community, error } = await supabase
      .from('Community')
      .select('*')
      .eq('community_magnets', magnetuuid);
    console.log('supabase_response', Community);
    return Community?.[0];
  } catch (err) {
    console.log(err);
    console.log('getPropertyinfo.error', err);
  }
};

export const getMagnetTemplate = async (
  magnetId,
  setMagnetSettings,
  entratauser,
  seentratauser,
  entratapass,
  setentratapass,
  entratapropertyId,
  setentratapropertyId
) => {
  get(`/magnets/template?magnet_uuid=${magnetId}`, { auth: false })
    .then((data) => {
      const extractedTemplateData = data.magnet.magnet_details.template;
      if (!entratauser || !entratapass || !entratapropertyId) {
        console.log('rendere_entrata_part');
        if (data.magnet?.integration_details['api-entrata']) {
          seentratauser(
            data.magnet?.integration_details['api-entrata']?.username
          );
          setentratapass(
            data.magnet?.integration_details['api-entrata']?.password
          );
          setentratapropertyId(
            data.magnet?.integration_details['api-entrata']?.property_id
          );
        }
      }
      console.log('whole?.data', data.magnet);
      console.log(
        'extractedTemplateData?.magnetSettings',
        extractedTemplateData?.magnetSettings
      );
      setMagnetSettings(extractedTemplateData?.magnetSettings || {});
    })
    .catch((error) => {
      console.log('error@getVideoTemplate: ', error.message);
    });
};

export const getProperty = async (integrationId) => {
  try {
    // const data = await getEntrataData(integrationId);
    // console.log("data",data)
    const query = new URLSearchParams(window.location.search);
    const entratauser = query.get('entratauser');
    const entratapass = query.get('entratapass');
    const entratapropertyId = query.get('entratapropertyId');
    let entratadomain = query.get('entratadomain');
    let creds = {
      username: entratauser,
      password: entratapass,
    };
    if (entratadomain) {
      creds['entratadomain'] = entratadomain;
    }
    const res = await axios.post(
      `https://api.leasemagnets.com/integrations/entrata/getPropertyinfo`,
      {
        creds: creds,
        propertyId: entratapropertyId,
      }
    );
    console.log(res);
    return res?.data?.resp?.result?.PhysicalProperty?.Property[0];
  } catch (err) {
    console.log(err);
    console.log('getPropertyinfo.error', err);
  }
};

export const getAvailablePropertyHours = (selectedDate, propertyInfo) => {
  let allHours = [
    '12:00 AM',
    '01:00 AM',
    '02:00 AM',
    '03:00 AM',
    '04:00 AM',
    '05:00 AM',
    '06:00 AM',
    '07:00 AM',
    '08:00 AM',
    '09:00 AM',
    '10:00 AM',
    '11:00 AM',
    '12:00 PM',
    '01:00 PM',
    '02:00 PM',
    '03:00 PM',
    '04:00 PM',
    '05:00 PM',
    '06:00 PM',
    '07:00 PM',
    '08:00 PM',
    '09:00 PM',
    '10:00 PM',
    '11:00 PM',
  ];
  let allhours_new = [
    '6:00 AM',
    '6:30 AM',
    '7:00 AM',
    '7:30 AM',
    '8:00 AM',
    '8:30 AM',
    '9:00 AM',
    '9:30 AM',
    '10:00 AM',
    '10:30 AM',
    '11:00 AM',
    '11:30 AM',
    '12:00 PM',
    '12:30 PM',
    '1:00 PM',
    '1:30 PM',
    '2:00 PM',
    '2:30 PM',
    '3:00 PM',
    '3:30 PM',
    '4:00 PM',
    '4:30 PM',
    '5:00 PM',
    '5:30 PM',
    '6:00 PM',
    '6:30 PM',
    '7:00 PM',
    '7:30 PM',
    '8:00 PM',
    '8:30 PM',
    '9:00 PM',
    '9:30 PM',
    '10:00 PM',
    '10:30 PM',
    '11:00 PM',
    '11:30 PM',
  ];
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  let theDay = '';
  if (selectedDate) {
    theDay = weekDays[new Date(selectedDate).getDay()];
    let selectedDayObj = {};
    propertyInfo?.PropertyHours?.OfficeHours?.OfficeHour?.map((item) => {
      // get office hours from entrata
      if (item.Day == theDay) {
        selectedDayObj = item;
      }
    });
    console.log('selectedDayObj_available_hours_entrata', selectedDayObj);
    let availHours = [];
    const query = new URLSearchParams(window.location.search);
    const start = query.get('start');
    const end = query.get('end');
    const saturdaystatus = query.get('saturdaystatus');
    const sundaystatus = query.get('sundaystatus');
    const saturdaystart = query.get('saturdaystart');
    const saturdayend = query.get('saturdayend');
    const sundaystart = query.get('sundaystart');
    const sundayend = query.get('sundayend');
    const hours_updated = query.get('hours_updated');
    console.log({ hours_updated });
    if (hours_updated) {
      allHours = allhours_new;
    }
    console.log({
      start,
      end,
      saturdaystart,
      saturdayend,
      sundaystart,
      sundayend,
    });

    // if we have start and end hours in params, then we overwrite with entrata open and close hour
    if (saturdaystatus == 'enabled' && new Date(selectedDate).getDay() == 6) {
      selectedDayObj['OpenTime'] = allHours[saturdaystart];
      selectedDayObj['CloseTime'] = allHours[saturdayend];
    } else if (
      sundaystatus == 'enabled' &&
      new Date(selectedDate).getDay() == 0
    ) {
      selectedDayObj['OpenTime'] = allHours[sundaystart];
      selectedDayObj['CloseTime'] = allHours[sundayend];
    } else if (start && end) {
      selectedDayObj['OpenTime'] = allHours[start];
      selectedDayObj['CloseTime'] = allHours[end];
    }
    console.log('selectedDayObj', selectedDayObj);

    const startindex = allHours.findIndex((item) => {
      return (
        `${Number(selectedDayObj?.OpenTime?.split(':')[0])}:${
          selectedDayObj?.OpenTime?.split(':')[1]
        }` === `${Number(item?.split(':')[0])}:${item?.split(':')[1]}`
      );
    });

    const endindex = allHours.findIndex((item) => {
      return (
        `${Number(item?.split(':')[0])}:${item?.split(':')[1]}` ===
        `${Number(selectedDayObj?.CloseTime?.split(':')[0])}:${
          selectedDayObj?.CloseTime?.split(':')[1]
        }`
      );
    });

    allHours.map((item, index) => {
      if (index >= startindex && index <= endindex) {
        availHours.push(item);
      }
    });
    return availHours;
  }
};

export const bookAppointment = async (
  uuid,
  obj,
  userInfo,
  tourType,
  onError
) => {
  // Declare variables at function scope for cleanup access
  let bookingKey = null;
  let bookingSessionId = null;
  
  try {
    console.log('obj**', obj);
    const query = new URLSearchParams(window.location.search);
    const entratauser = query.get('entratauser');
    const entratapass = query.get('entratapass');
    const entratapropertyId = query.get('entratapropertyId');
    const timezone = query.get('timezone') || 'EST';
    
    // Generate unique booking session ID to prevent duplicates
    bookingSessionId = `booking_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    console.log('Booking Session ID:', bookingSessionId);
    
    // Check if this exact booking is already in progress
    bookingKey = `${uuid}_${userInfo.email}_${obj.metadata[0].tour_time_start}`;
    if (window.__bookingInProgress && window.__bookingInProgress[bookingKey]) {
      console.log('Duplicate booking attempt detected and prevented:', bookingKey);
      return false;
    }
    
    // Mark this booking as in progress
    if (!window.__bookingInProgress) window.__bookingInProgress = {};
    window.__bookingInProgress[bookingKey] = bookingSessionId;
    
    let form_data = {
      source: 'cta_tour_mini_app',
      lead_name: `${userInfo.firstname} ${userInfo.lastname}`,
      lead_phone: `+1${userInfo.phone}`,
      lead_email: userInfo.email,
      first_name: userInfo.firstname,
      last_name: userInfo.lastname,
      email: userInfo.email,
      phone: `+1${userInfo.phone}`,
      booking_session_id: bookingSessionId,
      ...obj,
    };
    
    console.log('bookAppointment_obj', form_data);
    
    // Always save to the lead database
    saveLeadinDB(uuid, {
      form_data,
      form_route: null,
      video_time: 0,
    });
    
    // If Entrata credentials are available, make the Entrata API call using the new endpoint
    if (entratauser && entratapropertyId && uuid) {
      try {
        // Get the appointment time details from metadata
        const metadata = obj.metadata[0];
        const tourTimeStartString = metadata.tour_time_start_originating_timezone;
        const tourTimeStart = metadata.tour_time_start;
        const tourTimeFrom = metadata.tour_time_from;
        const tourTimeTo = metadata.tour_time_to;
        const customNotes = metadata.custom_notes || '';
        
        console.log('Appointment booking data before conversion:', {
          bookingSessionId,
          tourTimeStartString,
          tourTimeStart,
          tourTimeFrom,
          tourTimeTo,
          originalTimezone: timezone,
          customNotes,
          entrataCredentials: {
            hasUsername: !!entratauser,
            hasPropertyId: !!entratapropertyId
          }
        });
        
        // Parse the appointment date and time from the ISO string
        const appointmentDate = new Date(tourTimeStart);
        
        // Format the appointment date to MM/DD/YYYY for Entrata
        const formattedAppointmentDate = `${(appointmentDate.getMonth() + 1).toString().padStart(2, '0')}/${appointmentDate.getDate().toString().padStart(2, '0')}/${appointmentDate.getFullYear()}`;
        
        // Convert the time to 12-hour format for Entrata
        const appointmentHour24 = appointmentDate.getHours();
        const appointmentMinutes = appointmentDate.getMinutes();
        const appointmentHour12 = appointmentHour24 === 0 ? 12 : appointmentHour24 > 12 ? appointmentHour24 - 12 : appointmentHour24;
        const appointmentAmpm = appointmentHour24 >= 12 ? 'pm' : 'am';
        const timeFrom = `${appointmentHour12.toString().padStart(2, '0')}:${appointmentMinutes.toString().padStart(2, '0')}${appointmentAmpm}`;
        
        // Calculate timeTo (30 minutes later)
        const endTime = new Date(appointmentDate.getTime() + 30 * 60 * 1000);
        const endHour24 = endTime.getHours();
        const endMinutes = endTime.getMinutes();
        const endHour12 = endHour24 === 0 ? 12 : endHour24 > 12 ? endHour24 - 12 : endHour24;
        const endAmpm = endHour24 >= 12 ? 'pm' : 'am';
        const timeTo = `${endHour12.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}${endAmpm}`;
        
        // Enhanced timezone mapping to support both old and new formats
        const timezoneMap = {
          'EST': 'America/New_York',
          'CST': 'America/Chicago', 
          'MST': 'America/Denver',
          'PST': 'America/Los_Angeles',
          'EDT': 'America/New_York',
          'CDT': 'America/Chicago', 
          'MDT': 'America/Denver',
          'PDT': 'America/Los_Angeles',
          'America/Phoenix': 'America/Phoenix', // MST (Arizona - no DST)
        };
        
        // Determine timezone for Entrata - use mapping or default
        const entrataTimezone = timezoneMap[timezone] || 'America/New_York';
        
        console.log('Converting appointment data for Entrata:', {
          original: tourTimeStart,
          originalTimezone: timezone,
          formattedDate: formattedAppointmentDate,
          timeFrom: timeFrom,
          timeTo: timeTo,
          entrataTimezone: entrataTimezone,
          appointmentDate: appointmentDate
        });
        
        // Prepare tour scheduling data using the new endpoint format (matching test scheduler)
        const tourScheduling = {
          has_appointment: true,
          appointmentDate: formattedAppointmentDate,
          timeFrom: timeFrom,
          timeTo: timeTo,
          timezone: entrataTimezone,
          eventReasons: tourType === 'in-person' ? 'In-Person Tour' : 'Virtual Tour',
          comments: customNotes || metadata.tour_summary || `${tourType === 'in-person' ? 'In-Person' : 'Virtual'} tour scheduled via LeaseMagnets`
        };
        
        // Get originating source ID from magnet settings or use default
        let originatingSourceId = 'leasemagnets_tour_video'; // Default
        
        // Try to get the source ID from the magnet's integration details
        try {
          const magnetTemplateResp = await get(`/magnets/template?magnet_uuid=${uuid}`, { auth: false });
          const entrataIntegration = magnetTemplateResp?.magnet?.integration_details?.['api-entrata'];
          if (entrataIntegration?.originating_source_id) {
            originatingSourceId = entrataIntegration.originating_source_id;
          }
        } catch (e) {
          console.log('Could not fetch originating source ID from magnet settings, using default');
        }
        
        const entrataPayload = {
          creds: {
            username: entratauser,
          },
          property_id: entratapropertyId,
          originating_source_id: originatingSourceId,
          first_name: userInfo.firstname,
          last_name: userInfo.lastname,
          email: userInfo.email,
          phone: userInfo.phone.startsWith('+1') ? userInfo.phone : `+1${userInfo.phone}`,
          custom_notes: customNotes,
          booking_session_id: bookingSessionId,
          ...tourScheduling,
        };
        
        console.log('Sending to new Entrata API endpoint:', JSON.stringify(entrataPayload, null, 2));
        
        // Use the new endpoint with the post function from request utils
        let entrataResponse;
        try {
          entrataResponse = await post(
            `/api/integrations/entrata/sendLeads`,
            entrataPayload,
            { 
              auth: false, 
              host: 'https://leasemagnets.app',
              // Remove credentials for external API to avoid CORS issues
              noCreds: true
            }
          );
        } catch (requestError) {
          console.error('Request utility failed, trying direct fetch:', requestError);
          
          // Fallback to direct fetch if request utility fails
          try {
            const response = await fetch('https://leasemagnets.app/api/integrations/entrata/sendLeads', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(entrataPayload),
            });
            
            const responseText = await response.text();
            console.log('Direct fetch response text:', responseText);
            
            try {
              entrataResponse = JSON.parse(responseText);
            } catch (parseError) {
              entrataResponse = { 
                status: 'fail', 
                error: `Invalid JSON response: ${parseError}`,
                rawResponse: responseText
              };
            }
          } catch (fetchError) {
            console.error('Direct fetch also failed:', fetchError);
            throw fetchError;
          }
        }
        
        console.log('Entrata API response:', entrataResponse);
        
        // Enhanced response handling (matching test scheduler logic)
        if (entrataResponse?.response?.code === 200) {
          console.log('Entrata appointment booked successfully via new endpoint');
          // Clean up booking progress tracking
          delete window.__bookingInProgress[bookingKey];
          return true;
        } else if (entrataResponse?.error) {
          const errorMessage = entrataResponse?.error?.message || entrataResponse?.error || 'Unknown error';
          console.error('Entrata booking failed:', errorMessage);
          if (onError) onError(`Entrata booking failed: ${errorMessage}`);
          // Clean up booking progress tracking
          delete window.__bookingInProgress[bookingKey];
          return false;
        } else if (entrataResponse?.status === 'fail') {
          console.error('Entrata booking failed:', entrataResponse?.error);
          if (onError) onError(`Entrata booking failed: ${entrataResponse?.error}`);
          // Clean up booking progress tracking
          delete window.__bookingInProgress[bookingKey];
          return false;
        } else {
          console.log('Unexpected Entrata response format:', entrataResponse);
          // If we can't determine success/failure but no obvious error, treat as success
          // since we saved to our database
          // Clean up booking progress tracking
          delete window.__bookingInProgress[bookingKey];
          return true;
        }
        
      } catch (entrataError) {
        console.error('Error calling new Entrata API endpoint:', entrataError);
        if (onError) onError(`Failed to book appointment with Entrata: ${entrataError.message}`);
        // Clean up booking progress tracking
        delete window.__bookingInProgress[bookingKey];
        // Continue with success since we saved to our database
        return true;
      }
    } else {
      console.log('No Entrata credentials found, appointment saved to LeaseMagnets database only');
      // Clean up booking progress tracking
      delete window.__bookingInProgress[bookingKey];
    }
    
    // Clean up booking progress tracking
    delete window.__bookingInProgress[bookingKey];
    return true;
  } catch (err) {
    console.log('Error in bookAppointment:', err);
    if (onError) onError(`Booking failed: ${err.message}`);
    // Clean up booking progress tracking on error
    if (window.__bookingInProgress && bookingKey) {
      delete window.__bookingInProgress[bookingKey];
    }
    return false;
  }
};
